import { render } from "./CompetitionBacklinks.vue?vue&type=template&id=2ca23f32&scoped=true"
import script from "./CompetitionBacklinks.vue?vue&type=script&lang=js"
export * from "./CompetitionBacklinks.vue?vue&type=script&lang=js"

import "./CompetitionBacklinks.vue?vue&type=style&index=0&id=2ca23f32&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.hikeseo.co/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca23f32"]])

export default __exports__